import { useState } from 'react'
import { PageHeader } from '../../components/PageHeader/PageHeader'
import { EditEntityForm } from '../../components/EditEntityForm/EditEntityForm'
import { PageLoadingShell } from '../PageLoadingShell/PageLoadingShell'
import type { EditEntityPageProps } from './EditEntityPage.types'

export function EditEntityPage({
  title,
  backTo,
  note,
  loadingLabel,
  rows,
  isLoading,
  loadError,
  submitLabel = 'Save',
  onSubmit,
}: EditEntityPageProps) {
  const [saveError, setSaveError] = useState<string | null>(null)

  async function handleSubmit(body: Record<string, unknown>) {
    setSaveError(null)
    try {
      await onSubmit(body)
    } catch (err) {
      setSaveError(err instanceof Error ? err.message : 'Failed to save')
    }
  }

  return (
    <PageLoadingShell
      loadingLabel={loadingLabel}
      isLoading={isLoading}
      error={loadError}
    >
      <PageHeader title={title} />
      <section className="content-card content-card--padded" aria-label={title}>
        {note && (
          <div className="alert alert-info" role="note">
            {note}
          </div>
        )}
        {saveError && (
          <div className="alert alert-danger" role="alert">
            <strong>Error:</strong> {saveError}
          </div>
        )}
        <EditEntityForm
          rows={rows}
          onSubmit={handleSubmit}
          submitLabel={submitLabel}
          cancelHref={backTo}
        />
      </section>
    </PageLoadingShell>
  )
}
